import { RESULT_RANGE, type RuleBoxPreviewEntry } from "@loot-os/api-contract";

/** How many drop-table rows the preview lists before "Show all". */
export const PREVIEW_ROWS = 20;

/** A weight out of 1,000,000 as a percentage a person reads: "12.5%", "<0.01%". */
export function oddsPercent(weight: number): string {
  const pct = (weight / RESULT_RANGE) * 100;
  if (pct > 0 && pct < 0.01) return "<0.01%";
  return `${Number(pct.toFixed(2))}%`;
}

/** The entries dearest first (then likeliest), the first `limit` of them unless `all`. */
export function previewRows(
  entries: RuleBoxPreviewEntry[],
  all: boolean,
  limit = PREVIEW_ROWS,
): RuleBoxPreviewEntry[] {
  const sorted = [...entries].sort((a, b) => b.valueCents - a.valueCents || b.weight - a.weight);
  return all ? sorted : sorted.slice(0, limit);
}
